@if (subscriptionBanner && subscriptionBanner.displayFlag) {
  <div class="info-banner-card warn fx-fill">
    <mat-card-content [ngClass]="subscriptionBanner.cssClass" class="fxl-row fxla-center-center">
      @if (subscriptionBanner.suspendedFlag || subscriptionBanner.activeSubscriptionExistenceFlag === false) {
        <div>
          Votre abonnement PROTHESIS CLOUD est {{ subscriptionBanner.suspendedFlag ? 'suspendu' : 'terminé' }}, votre accès au service CLOUD
          a été désactivé.
          <br />
          Pour réactiver votre abonnement, nous vous invitons à
          <a class="text-nowrap" href="https://prothesis.cloud/contact-us" mat-menu-item target="_blank">
            contacter le service client Prothesis Dental Solutions</a
          >.
        </div>
      }
      @if (!subscriptionBanner.suspendedFlag && subscriptionBanner.activeSubscriptionExistenceFlag === true) {
        <div>
          Votre {{ subscriptionBanner.lastActiveSubscriptionDisplayLabel }} expire le
          {{ subscriptionBanner.lastSubscriptionEndDate | customDate: 'short' }} -
          <a class="text-nowrap" href="https://prothesis.cloud/contact-us" mat-menu-item target="_blank"
            >contacter le service client Prothesis Dental Solutions</a
          >
        </div>
      }
    </mat-card-content>
  </div>
}
